/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awake_White_Mantis_SlurpInputs */

const fr_awake_white_mantis_slurp = /** @type {(inputs: Awake_White_Mantis_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de série`)
};

/**

* @param {Awake_White_Mantis_SlurpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awake_white_mantis_slurp = /** @type {((inputs?: Awake_White_Mantis_SlurpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awake_White_Mantis_SlurpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awake_white_mantis_slurp(inputs)
});